import { render, staticRenderFns } from "./FacilitiesDashboard.vue?vue&type=template&id=1bc38baf&scoped=true&"
import script from "./FacilitiesDashboard.vue?vue&type=script&lang=js&"
export * from "./FacilitiesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FacilitiesDashboard.vue?vue&type=style&index=0&id=1bc38baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc38baf",
  null
  
)

export default component.exports